document.addEventListener('DOMContentLoaded', function() {
    const quiz = document.querySelector('.quiz-container');
    if (!quiz) return;

    const questions = document.querySelectorAll('.question');
    const options = document.querySelectorAll('.option');
    const progressBar = document.querySelector('.progress');
    const result = document.querySelector('.result');
    const emailButton = document.querySelector('.email-button');
    
    let currentQuestion = 0;
    let answers = {};
  // Mapping titre → URL de collection
const collectionUrls = {
  // Textile & Mode
  "Vestes & pulls": "/collections/vestes-pulls",
  "Hauts": "/collections/hauts",
  "Bas": "/collections/bas",
  "Accessoires textile": "/collections/accessoires-textile",
  "Chaussures": "/collections/chaussures",
  "Enfants": "/collections/enfants",
  // Bureau & écriture
  "Stylos & crayons": "/collections/stylos-crayons",
  "Carnets": "/collections/carnets",
  "Accessoires bureau": "/collections/accessoires-bureau",
  "Trophées": "/collections/trophees",
  // Sacs & bagages
  "Totebags & sacs de shopping": "/collections/totebags-sacs-de-shopping",
  "Bagages": "/collections/bagages",
  "Sacs pour le quotidien": "/collections/sacs-quotidien",
  // Alimentation et boissons
  "Manger & boire": "/collections/manger-boire",
  "Vins & spiritueux": "/collections/vins-spiritueux",
  "Gourdes & bouteilles": "/collections/gourdes-bouteilles",
  "Tasses & mug": "/collections/tasses-mug",
  "Gobelets & verres": "/collections/gobelets-verres",
  "Lunchbox & couverts": "/collections/lunchbox-couverts",
  "Accessoires alimentations": "/collections/accessoires-alimentations",
  // Maison
  "Plaid & couverture": "/collections/plaid-couverture",
  "Serviette & gants": "/collections/serviette-gants",
  "Plantes & jardinage": "/collections/plantes-jardinage",
  "Décoration & accessoires": "/collections/decoration-accessoires",
  // Technologie
  "Chargeurs": "/collections/chargeurs",
  "Accessoires audio": "/collections/accessoires-audio",
  "Accessoires pour ordinateurs": "/collections/accessoires-ordinateurs",
  "Horlogerie": "/collections/horlogerie",
  // Loisir & sport
  "Jeux de société": "/collections/jeux-de-societe",
  "Peluche & jouets": "/collections/peluche-jouets",
  "Accessoires pour animaux": "/collections/accessoires-animaux",
  "Beauté & bien-être": "/collections/beaute-bien-etre",
  "Sports": "/collections/sports",
  "Fête": "/collections/fete",
  // PLV
  "Accessoires événementiel": "/collections/accessoires-evenementiel",
  "Mobilier événementiel": "/collections/mobilier-evenementiel",
  // Spécial bébé (si tu veux l’ajouter)
  "enfants": "/collections/enfants"
};

    // Gestion des options
    options.forEach(option => {
        option.addEventListener('click', function() {
            const questionId = this.closest('.question').id;
            const optionValue = this.getAttribute('data-value');
            
            // Désélectionner les autres options de la même question
            const otherOptions = this.closest('.question').querySelectorAll('.option');
            otherOptions.forEach(opt => opt.classList.remove('selected'));
            
            // Sélectionner l'option cliquée
            this.classList.add('selected');
            
            // Sauvegarder la réponse
            answers[questionId] = optionValue;
            
            // Passer à la question suivante après un court délai
            setTimeout(() => {
                if (currentQuestion < questions.length - 1) {
                    questions[currentQuestion].classList.remove('active');
                    currentQuestion++;
                    questions[currentQuestion].classList.add('active');
                    updateProgress();
                } else {
                    showResults();
                }
            }, 500);
        });
    });

    // Mise à jour de la barre de progression
    function updateProgress() {
        const progress = ((currentQuestion + 1) / questions.length) * 100;
        progressBar.style.width = progress + '%';
    }

    // Affichage des résultats
    function showResults() {
        document.querySelector('.quiz-container').style.display = 'none';
        result.classList.add('active');
        
        // Calculer les recommandations
        const recommendations = calculateRecommendations(answers);
        
        // Afficher les recommandations dans la grille
        const grid = document.querySelector('.recommendation-grid');
        grid.innerHTML = '';
        recommendations.forEach(rec => {
            grid.innerHTML += `
    <div class="product-card">
        <span class="badge">${rec.badge}</span>
        <h3>${rec.title}</h3>
        <p class="argument">${rec.argument}</p>
       <a href="${collectionUrls[rec.title] || '/pages/contact'}" class="cta-button" target="_blank">Voir la collection</a>
    </div>
`;
        });
    }
function calculateRecommendations(answers) {
    // On récupère le type de produit choisi
    const type = answers['type'];

    // Mapping des sous-catégories par type principal
    const sousCategories = {
        "textile": [
            {
                title: "Vestes & pulls",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/vestes-pulls.jpg",
                argument: "Pour un look professionnel et confortable.",
                badge: "Textile"
            },
            {
                title: "Hauts",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/hauts.jpg",
                argument: "T-shirts, polos, chemises personnalisés.",
                badge: "Textile"
            },
            {
                title: "Bas",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/bas.jpg",
                argument: "Pantalons, shorts, pour compléter la tenue.",
                badge: "Textile"
            },
            {
                title: "Accessoires textile",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/accessoires-textile.jpg",
                argument: "Bonnets, écharpes, gants, casquettes…",
                badge: "Accessoire"
            },
            {
                title: "Chaussures",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/chaussures.jpg",
                argument: "Pour un style unique jusqu’au bout des pieds.",
                badge: "Mode"
            },
            {
                title: "Enfants",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/enfants.jpg",
                argument: "Textile et goodies adaptés aux plus jeunes.",
                badge: "Kids"
            }
        ],
        "bureau": [
            {
                title: "Stylos & crayons",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/stylo.png",
                argument: "Indispensable au quotidien, visibilité assurée.",
                badge: "Bureau"
            },
            {
                title: "Carnets",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/carnet.jpg",
                argument: "Pour prendre des notes partout.",
                badge: "Bureau"
            },
            {
                title: "Accessoires bureau",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/accessoires-bureau.jpg",
                argument: "Organisez votre espace de travail.",
                badge: "Bureau"
            },
            {
                title: "Trophées",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/trophee.jpg",
                argument: "Pour récompenser et motiver.",
                badge: "Récompense"
            }
        ],
        "sacs": [
            {
                title: "Totebags & sacs de shopping",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/totebag.jpg",
                argument: "Pratique, écologique et personnalisable.",
                badge: "Sacs"
            },
            {
                title: "Bagages",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/bagages.jpg",
                argument: "Pour les déplacements pros ou persos.",
                badge: "Voyage"
            },
            {
                title: "Sacs pour le quotidien",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/sac-quotidien.jpg",
                argument: "Sac à dos, sac ordinateur, sac de sport…",
                badge: "Sacs"
            }
        ],
        "alim": [
            {
                title: "Manger & boire",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/manger-boire.jpg",
                argument: "Gourmandises et snacks personnalisés.",
                badge: "Gourmand"
            },
            {
                title: "Vins & spiritueux",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/vins.jpg",
                argument: "Pour les amateurs de bons crus.",
                badge: "Cadeau"
            },
            {
                title: "Gourdes & bouteilles",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/gourde.jpg",
                argument: "Hydratez-vous avec style.",
                badge: "Éco"
            },
            {
                title: "Tasses & mug",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/mug.jpg",
                argument: "Pour le café ou le thé au bureau.",
                badge: "Bureau"
            },
            {
                title: "Gobelets & verres",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/verre.jpg",
                argument: "Pour tous vos événements.",
                badge: "Événement"
            },
            {
                title: "Lunchbox & couverts",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/lunchbox.jpg",
                argument: "Pour la pause déjeuner nomade.",
                badge: "Pratique"
            },
            {
                title: "Accessoires alimentations",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/accessoires-alim.jpg",
                argument: "Tabliers, pailles, planches, etc.",
                badge: "Cuisine"
            }
        ],
        "maison": [
            {
                title: "Plaid & couverture",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/plaid.jpg",
                argument: "Pour un cadeau chaleureux.",
                badge: "Cocooning"
            },
            {
                title: "Serviette & gants",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/serviette.jpg",
                argument: "Pour le bien-être et la détente.",
                badge: "Bien-être"
            },
            {
                title: "Plantes & jardinage",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/plante.jpg",
                argument: "Apportez de la verdure au bureau.",
                badge: "Nature"
            },
            {
                title: "Décoration & accessoires",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/decoration.jpg",
                argument: "Pour embellir tous les espaces.",
                badge: "Déco"
            }
        ],
        "tech": [
            {
                title: "Chargeurs",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/chargeur.jpg",
                argument: "Toujours connecté, partout.",
                badge: "Tech"
            },
            {
                title: "Accessoires audio",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/audio.jpg",
                argument: "Enceintes, écouteurs, casques…",
                badge: "Tech"
            },
            {
                title: "Accessoires pour ordinateurs",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/usb.jpg",
                argument: "Clés USB, souris, tapis, etc.",
                badge: "Bureau"
            },
            {
                title: "Horlogerie",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/montre.jpg",
                argument: "Montres connectées et classiques.",
                badge: "Premium"
            }
        ],
        "loisir": [
            {
                title: "Jeux de société",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/jeux.jpg",
                argument: "Pour renforcer la cohésion.",
                badge: "Fun"
            },
            {
                title: "Peluche & jouets",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/peluche.jpg",
                argument: "Pour petits et grands enfants.",
                badge: "Kids"
            },
            {
                title: "Accessoires pour animaux",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/animaux.jpg",
                argument: "Pour les amis à quatre pattes.",
                badge: "Animaux"
            },
            {
                title: "Beauté & bien-être",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/beaute.jpg",
                argument: "Pour prendre soin de soi.",
                badge: "Bien-être"
            },
            {
                title: "Sports",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/sport.jpg",
                argument: "Pour bouger et se dépasser.",
                badge: "Sport"
            },
            {
                title: "Fête",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/fete.jpg",
                argument: "Pour célébrer tous les événements.",
                badge: "Fête"
            },
            {
                title: "Enfants",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/enfants.jpg",
                argument: "Des goodies pour les plus jeunes.",
                badge: "Kids"
            }
        ],
        "plv": [
            {
                title: "Accessoires événementiel",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/evenementiel.jpg",
                argument: "Pour vos salons et événements.",
                badge: "PLV"
            },
            {
                title: "Mobilier événementiel",
                image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/mobilier.jpg",
                argument: "Comptoirs, assises, mange-debout…",
                badge: "PLV"
            }
        ]
    };

    // On retourne les sous-catégories du type choisi, ou une sélection par défaut
    return sousCategories[type] || [
        {
            title: "Stylos & crayons",
            image: "https://cdn.shopify.com/s/files/1/0866/3318/5554/files/stylo.png",
            argument: "Indispensable au quotidien, visibilité assurée.",
            badge: "Bureau"
        }
    ];
}

    // Gestion du partage par email
    if(emailButton){
      emailButton.addEventListener('click', function() {
          const email = prompt('Entrez votre adresse email pour recevoir les recommandations :');
          if (email) {
              alert('Les recommandations ont été envoyées à ' + email);
          }
      });
    }
});